import { Box } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import { Condition } from 'Component/others';
import formatCurrency from 'Helper/formatCurrency';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import AchievementRank from 'Component/achievement-rank';
import { PODIUM_STYLES } from 'View/host-achievement-detail/component/rank-podium/const';

import styles from './styles.module.css';
import formatNumber from 'Helper/formatNumber';

const RankPodium = ({ rankPosition, data }) => {
  const isDataAvailable = !isEmpty(data);
  const displayValue = isDataAvailable ? (data?.isCurrency ? formatCurrency(data?.value) : `${formatNumber(data?.value, 1)}%`) : '';
  const podiumStyle = PODIUM_STYLES[rankPosition] || {};

  return (
    <Box
      className={styles['rank-podium__container']}
      backgroundColor={isDataAvailable ? podiumStyle.bgColor : PODIUM_STYLES.null.bgColor}
      height={podiumStyle.height}
    >
      <Box className={styles['inner-podium__container']}>
        <Box className={styles['rank__container']}>
          <AchievementRank rankPosition={isDataAvailable ? rankPosition : null} size="lg" />
        </Box>
        <Box className={styles['podium-values__container']}>
          <Condition statement={isDataAvailable}>
            <TextSemiBold className={styles['host-name__text']}>{data?.hostName}</TextSemiBold>
            <TextRegular className={styles['value__text']}>{displayValue}</TextRegular>
          </Condition>
        </Box>
      </Box>
    </Box>
  );
};

export default RankPodium;
